import { post, get, type RequestConfig } from "../shared/api-client";
import {
  JIVANDHARA_BASE,
  unwrapItem,
} from "../admin/list-api-helpers";

const SILENT: RequestConfig = { showNotification: false };
const BASE = `${JIVANDHARA_BASE}/tiffin-seva-donations`;
const SCHEMES_BASE = `${JIVANDHARA_BASE}/tiffin-seva-schemes`;

export interface TiffinSevaCreateOrderPayload {
  scheme: number;
  times: number;
  donor_name: string;
  mobile_number: string;
  email: string;
  city: string;
  full_address: string;
  state: string;
  pincode: string;
  country: string;
  occasion?: string;
  display_name?: string;
  special_instructions?: string;
  is_anonymous: boolean;
  info_confirmed: boolean;
  contact_consent: boolean;
}

export interface TiffinSevaCreateOrderResult {
  order_id: string;
  amount: number;
  currency: string;
  key_id?: string;
  donation_id?: number;
  total_amount?: string;
  scheme_name?: string;
}

export interface TiffinSevaVerifyPaymentPayload {
  razorpay_order_id: string;
  razorpay_payment_id: string;
  razorpay_signature: string;
}

class PublicTiffinSevaDonationService {
  listActiveSchemes = async (): Promise<any[]> => {
    const response = await get<any[] | { data: any[] }>(`${SCHEMES_BASE}/`, {
      params: { is_active: true },
      ...SILENT
    });
    if (Array.isArray(response)) {
      return response;
    }
    if (response && typeof response === "object" && "data" in response && Array.isArray(response.data)) {
      return response.data;
    }
    const unwrapped = unwrapItem(response as any);
    return Array.isArray(unwrapped) ? unwrapped : [];
  };

  createOrder = async (
    payload: TiffinSevaCreateOrderPayload
  ): Promise<TiffinSevaCreateOrderResult> => {
    const response = await post<any, TiffinSevaCreateOrderPayload>(
      `${BASE}/create-order/`,
      payload,
      SILENT
    );
    const data = response?.data || unwrapItem(response) || response;
    if (!data) {
      throw new Error("Failed to create tiffin seva payment order.");
    }
    if (data.data && typeof data.data === "object") {
      return data.data;
    }
    return data;
  };

  verifyPayment = async (
    payload: TiffinSevaVerifyPaymentPayload
  ): Promise<any> => {
    const response = await post<any, TiffinSevaVerifyPaymentPayload>(
      `${BASE}/verify-payment/`,
      payload,
      SILENT
    );
    return response?.data || unwrapItem(response) || response;
  };
}

export const publicTiffinSevaDonationService = new PublicTiffinSevaDonationService();
